import {
  MapPin,
  MessageCircle,
  Navigation,
  Clock,
  Share2,
  Store,
} from "lucide-react";
import { Seo } from "../components/Seo";
import { site, waLink, waGeneralMessage } from "../data/store";

export default function Kontak() {
  return (
    <>
      <Seo
        title="Kontak & Lokasi | Toko Bangunan NJA Bajawa"
        description="Hubungi Toko Bangunan Nuansa Jaya Abadi (NJA) di Jl. Basuki Rahmat, Tanalodu, Bajawa. WhatsApp 0851-4172-2822 untuk tanya harga dan ketersediaan."
        path="/kontak"
      />

      <section className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:py-16">
        <h1 className="text-3xl font-extrabold text-navy sm:text-4xl">
          Kontak & lokasi
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
          Hubungi kami untuk menanyakan harga, ketersediaan barang, atau arah
          menuju toko. Cara tercepat adalah melalui WhatsApp.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
              <Store className="h-5 w-5 text-brand" aria-hidden="true" />
              Nama usaha
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              {site.name} ({site.shortName})
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
              <MapPin className="h-5 w-5 text-brand" aria-hidden="true" />
              Alamat
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              {site.address}
              <br />
              {site.region}
            </p>
            {site.googleMapsUrl && (
              <a
                href={site.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-directions-button"
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-sm font-semibold text-white transition-colors duration-300 hover:bg-navy-light"
              >
                <Navigation className="h-4 w-4" aria-hidden="true" />
                Petunjuk Arah
              </a>
            )}
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
              <MessageCircle className="h-5 w-5 text-brand" aria-hidden="true" />
              WhatsApp
            </h2>
            <p className="mt-3 text-sm text-slate-600">{site.whatsappDisplay}</p>
            <a
              href={waLink(waGeneralMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-wa px-4 py-2 text-sm font-semibold text-white transition-colors duration-300 hover:bg-wa-dark"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              Chat Sekarang
            </a>
          </div>

          {site.openingHours.length > 0 && (
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
                <Clock className="h-5 w-5 text-brand" aria-hidden="true" />
                Jam buka
              </h2>
              <ul className="mt-3 space-y-1 text-sm text-slate-600">
                {site.openingHours.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            </div>
          )}

          {site.socials.length > 0 && (
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
                <Share2 className="h-5 w-5 text-brand" aria-hidden="true" />
                Media sosial
              </h2>
              <ul className="mt-3 space-y-2 text-sm">
                {site.socials.map((s) => (
                  <li key={s.label}>
                    <a
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${s.label} NJA`}
                      data-testid={`contact-social-${s.label.toLowerCase()}`}
                      className="inline-flex items-center gap-2 font-medium text-navy transition-colors hover:text-brand"
                    >
                      <s.icon className="h-4 w-4 text-brand" aria-hidden="true" />
                      {s.label} NJA
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {site.googleMapsEmbedUrl && (
          <div className="mt-10">
            <h2 className="text-lg font-semibold text-navy">Peta lokasi toko</h2>
            <div className="mt-4 overflow-hidden rounded-2xl border border-slate-200 shadow-sm">
              <iframe
                src={site.googleMapsEmbedUrl}
                title="Peta lokasi Toko Bangunan Nuansa Jaya Abadi di Bajawa"
                data-testid="contact-map-embed"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                className="h-80 w-full border-0"
              />
            </div>
          </div>
        )}

        <div className="mt-10 rounded-2xl border border-brand/30 bg-brand/5 p-6">
          <h2 className="text-lg font-semibold text-navy">
            Tips agar pertanyaan cepat terjawab
          </h2>
          <ul className="mt-3 space-y-2 text-sm leading-relaxed text-slate-600">
            <li>• Sebutkan jenis barang, ukuran, dan jumlah yang dibutuhkan.</li>
            <li>• Lampirkan foto barang atau instalasi lama bila ada.</li>
            <li>• Sebutkan merek yang biasa Anda pakai bila punya preferensi.</li>
          </ul>
        </div>
      </section>
    </>
  );
}
